import { orderAutomatizationSelectors } from '@/ModalWindows/OrderAutomatizationModal/services/selectors';
import { OrderAutomatizationProductModel } from '@/Models/OrderUserProducts/OrderAutomatizationProductModel';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useShipCheaperLogisticOptions = (
  orderId: number,
  selectedPackageKeys: { key: string; weight: string | number }[],
) => {
  const orderPackages = useSelector(orderAutomatizationSelectors.orderPackages);

  const currentOrderPackageOptions = useMemo(() => {
    const currentOrderPackages = orderPackages.find((op) => op.orderId === orderId && !op.isOwnContract);
    return currentOrderPackages?.packages;
  }, [orderId, orderPackages]);

  const currentOrderProductOptions = useMemo(() => {
    const currentOrderPackages = orderPackages.find((op) => op.orderId === orderId && !op.isOwnContract);

    if (currentOrderPackages) {
      const selectedPackageOptions = currentOrderPackages.packages.filter((p) =>
        selectedPackageKeys.map((p) => p.key).includes(p.key),
      );

      return selectedPackageOptions
        .reduce((arr: { product: OrderAutomatizationProductModel; count: number }[], curr) => {
          curr.products.forEach((p) => {
            arr.push({ product: p, count: 1 });
          });

          return arr;
        }, [])
        .map((p) => p.product);
    } // if

    return [];
  }, [orderId, orderPackages, selectedPackageKeys]);

  return {
    packageOptions: currentOrderPackageOptions,
    productOptions: currentOrderProductOptions,
  };
};
